import {
  createTheme,
  DEFAULT_THEME,
  defaultVariantColorsResolver,
  mergeMantineTheme,
  parseThemeColor,
  VariantColorsResolver,
  VariantColorsResolverInput,
} from "@mantine/core";

const variantColorResolver: VariantColorsResolver = (
  input: VariantColorsResolverInput,
) => {
  const defaultResolvedColors = defaultVariantColorsResolver(input);
  const parsedColor = parseThemeColor({
    color: input.color || input.theme.primaryColor,
    theme: input.theme,
  });

  if (parsedColor.isThemeColor && input.variant === "filled") {
    return {
      ...defaultResolvedColors,
      color: "var(--mantine-color-body)",
    };
  }

  return defaultResolvedColors;
};

const theme = mergeMantineTheme(
  DEFAULT_THEME,
  createTheme({
    colors: {
      // Primary forest green palette — canonical brand green: #2d7a4f (index 6, light mode primary)
      "forest": [
        "#f4faf7", // Lightest mint
        "#def2e7", // Light mint
        "#b9e4cd", // Soft green
        "#89d2aa", // Light forest
        "#57c187", // Medium forest
        "#3ba069", // Forest green
        "#2d7a4f", // ForestSync brand green ← primary (light mode)
        "#205a3a", // Deep forest
        "#163c27", // Dark forest
        "#0d2618", // Forest night
      ],
      // Secondary forest green - muted sage tones
      "sage": [
        "#f5f6f2", // Light sage
        "#e8ebe0", // Soft sage
        "#d6dcc5", // Medium sage
        "#c4ccaa", // Sage green
        "#a8b888", // True sage
        "#8da36d", // Deep sage
        "#738e55", // Dark sage
        "#5c7845", // Forest sage
        "#486238", // Sage shadow
        "#364c2d", // Sage night
      ],
      // Primary forest brown - warm timber tones
      "timber": [
        "#f5f3f0", // Light timber
        "#e9e3db", // Soft timber
        "#dbd1c3", // Medium timber
        "#cabda5", // Timber tan
        "#b5a485", // True timber
        "#9e8a66", // Deep timber
        "#85704b", // Dark timber
        "#6b583b", // Forest timber
        "#52432e", // Timber shadow
        "#3a3123", // Timber night
      ],
      // Secondary forest brown - rich earth tones
      "earth": [
        "#f6f4f0", // Light earth
        "#ebe5d8", // Soft earth
        "#ddd2bf", // Medium earth
        "#cdbaa0", // Earth tan
        "#b8a082", // True earth
        "#a08564", // Deep earth
        "#876b4a", // Dark earth
        "#6d533a", // Forest earth
        "#553f2d", // Earth shadow
        "#3d2e22", // Earth night
      ],
    },
    // other theme customizations
    primaryColor: "forest",
    primaryShade: { light: 6, dark: 3 },
    autoContrast: true,
    variantColorResolver,
  }),
);

export default theme;
